import { render } from "./PieChart.vue?vue&type=template&id=7a6c3788&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"

import "./PieChart.vue?vue&type=style&index=0&id=7a6c3788&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7a6c3788"

export default script